
const EditUserProfile=()=> {
  return (
    <>
     <div className="row mx-0 mx-lg-3">
             {/* <div className="col-lg-12">
                <div className="card border-0 shadow w-100 card-span mb-4">
                    <div className="card-header property-header py-3">
                        <div className="d-flex justify-content-between">
                            <h5 className="mb-0 property-heading-card">MY PROFILE</h5>
                            <i class="fa-regular fa-pen-to-square edit-icon"></i>
                        </div>
                    </div>
                    <div class="user-profile py-3 px-lg-4 px-2">
                        <div className="bio-picture d-flex justify-content-left">
                            <img src="/Assets/Images/user1-128x128.jpg" alt="profile-img" className="img-fluid rounded-circle"></img>
                        </div>
                        <div class="bio">
                            <p><span>First Name </span>: Nikita</p>
                        </div>
                        <div class="bio">
                            <p><span>Last Name </span>: abc</p>
                        </div>
                        <div class="bio">
                            <p><span>Position</span>: Jr. Dev</p>
                        </div>
                        <div class="bio">
                            <p><span>Email </span>: nikita@ginilytics.com</p>
                        </div>
                        <div class="bio">
                            <p><span>Address </span>: E288 Flexi tower ynr zen,15151</p>
                        </div>
                        <div class="bio">
                            <p><span>Address </span>: E288 Flexi tower ynr zen,15151</p>
                        </div>
                        <div class="bio">
                            <p><span>Address </span>: E288 Flexi tower ynr zen,15151</p>
                        </div>
                        <div class="bio">
                            <p><span>Contact </span>: 8894961574</p>
                        </div>
                    </div>
                    
                </div>
              </div> */}
             
       

             <div className="col-lg-6">
                    <div className="">
                        <img src="/Assets/Images/user1-128x128.jpg" alt="profile-img" className="img-fluid rounded-circle"></img>
                    </div>
                    <form className="row mt-4">
                        <div className="col-md-6 mb-2">
                            <label className="form-label">First Name</label>
                            <input type="text" className="form-control" />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="form-label">Last Name</label>
                            <input type="text" className="form-control" />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label  className="form-label">Email</label>
                            <input type="email" className="form-control"  />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label  className="form-label">Password</label>
                            <input type="password" className="form-control" />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label  className="form-label">Address</label>
                            <input type="text"className="form-control" placeholder="1234 Main St"/>
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="form-label">Address 2</label>
                            <input type="text"className="form-control" placeholder="Apartment, studio, or floor" />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="form-label">City</label>
                            <input type="text" className="form-control" />
                        </div>
                        <div className="col-md-6 mb-2">
                            <label className="form-label">State</label>
                            <input type="text" className="form-control" />
                        </div>
                        <div className="col-12 my-3 ">
                            <button type="submit" className="btn submit-button"> Update </button>
                            <button type="submit" className="btn btn-submit-secondary ms-3"> Cancel </button>
                        </div>
                    </form>

                </div>

        </div>
    </>
  )
}
export default  EditUserProfile